import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { searchProjects } from 'components/project/api';

export default class AssociatedProjectSelector extends React.Component {
  static propTypes = {
    displayOnlyListings: PropTypes.bool,
    onModelAdded: PropTypes.func.isRequired
  };

  static defaultProps = {
    displayOnlyListings: false
  };

  loadProjectOptions = (inputValue, callback) => {
    const { displayOnlyListings } = this.props;

    searchProjects(inputValue, (projects) => {
      const options = projects.map((project) => {
        if (!project.isAssignment || !displayOnlyListings) {
          return {
            value: project.id,
            label: project.displayName,
            type: 'Project'
          };
        }
      });

      callback(options.filter(Boolean));
    });
  }

  onSelected = (selection) => {
    this.props.onModelAdded({
      associatedModelId: selection.value,
      associatedModelType: selection.type,
      name: selection.label
    });
  }

  render() {
    return (
      <AsyncSelect
        autoFocus
        className="mb-4"
        loadOptions={this.loadProjectOptions}
        placeholder="Search Projects ..."
        value=""
        onChange={this.onSelected}
      />
    );
  }
}
